/* eslint-disable max-len */
export const ScenarioAnalysisConfig = {
	SCENARIO_ANALYSIS_CHART_TITLE: 'Scenario Analysis',
	SCENARIO_ANALYSIS_CHART_SUB_TITLE: 'SCENARIO_ANALYSIS_CHART_SUB_TITLE',
	AC_SPX_DN: 'US Large Cap Stocks Fall',
	AC_VIX_UP: 'Stock Market Volatility Rises',
	AC_USHY_UP: 'High Yield Spreads Widen',
	AC_CPI_UP: 'Inflation Rises',
	AC_10Y_UP: '10Y US Treasury Rate Rises',
	AC_OIL_UP: 'Oil Prices Rise',
	AC_SPX_DN_INFO_SUBTITLE: 'US Large Cap Stocks Fall',
	AC_VIX_UP_INFO_SUBTITLE: 'Stock Market Volatility Rises',
	AC_USHY_UP_INFO_SUBTITLE: 'High Yield Spreads Widen',
	AC_CPI_UP_INFO_SUBTITLE: 'Inflation Expectations Rise',
	AC_10Y_UP_INFO_SUBTITLE: '10-Yr U.S. Treasury Rate Rises',
	AC_OIL_UP_INFO_SUBTITLE: 'Oil Prices Rise',
	AC_SPX_DN_INFO_DESCRIPTION:
		'Defined as a 15% decrease in the S&P 500. The S&P 500 is a market cap weighted large cap equity index located in the United States. Generally decreasing equity prices are reflective of a slowdown in economic growth.',
	AC_VIX_UP_INFO_DESCRIPTION:
		'Defined as 20% increase in the CBOE (Chicago Board of Options Exchange) VIX Index .  The VIX typically serves as a gauge for volatility expectations in the market place. When it rises, investors are anticipating increased uncertainty and volatility.',
	AC_USHY_UP_INFO_DESCRIPTION:
		'Defined as a 200 basis point (2%) increase in spreads between a benchmark high yield bond index and a US Treasury index. Typically when high yield spreads widen it is function of an economic slowdown or risk-off environment as the underlying credit quality of the issuers decrease.',
	AC_CPI_UP_INFO_DESCRIPTION:
		'Defined as a 200 basis point (2%) increase in the difference between 2-Yr nominal US Treasury yields and 2-Yr Inflation Protected US Treasury yields (TIPS). Periods of inflation are usually characterized by higher growth, rising bonds yields and of course, increasing consumer prices.',
	AC_10Y_UP_INFO_DESCRIPTION:
		'Defined as a 100 basis point (1%) increase in the US 10-Year Treasury Rate. Typically rising rates are associated with increased expectations for US economic growth, rising equity prices and an increase in issuer credit quality for the area.',
	AC_OIL_UP_INFO_DESCRIPTION:
		'Defined as 35% increase in Crude Oil Prices. Oil prices are typically a function of supply and demand for the resource. An increase in price could indicate either an increase in demand due to instances such as pickup in global growth or reduction in supply due to the lack of availability of the resource.'
};

